import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { RoleStr } from '../Commons/Utils'

class MeetingDetail extends Component {
  render () {
    // 날짜 변환
    const newDate = new Date(this.props.item.createdAt)
    const newYear = newDate.getFullYear()
    const newMonth = newDate.getMonth() + 1
    const newDay = newDate.getDate()
    const week = new Array('일', '월', '화', '수', '목', '금', '토')
    const newDayName = week[newDate.getDay()]
    const day = newYear + '.' + newMonth + '.' + newDay + ' ' + '(' + newDayName + ')'

    const user = {
      role: '역할',
      name: '이름'
    }
    if (this.props.item.writer && this.props.item.writer !== '' && this.props.item.writer !== undefined) {
      user.role = RoleStr[this.props.item.writer.group]
      user.name = this.props.item.writer.name
    } else if (this.props.item.user && this.props.item.user.name) {
      user.role = '협력사'
      user.name = this.props.item.user.name
    }

    return (
      <Link to={`/meeting/${this.props.item._id}`}>
        <ul className="item">
          <li className="title"><p className="title_text">{this.props.item.title}</p><p className="reply_length">[{this.props.item.comments.length}]</p></li>
          <li className="name pc_v_impo">{user.role} {user.name}</li>
          <li className="date">{day}</li>
        </ul>
      </Link>
    )
  }
}

export default MeetingDetail



// WEBPACK FOOTER //
// ./Src/Components/Meeting/MeetingItem.js